var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMicOffNoShadow16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5841 7.3417L5.6445 2.40215C6.08426 1.56836 6.95969 1 7.96787 1C9.41762 1 10.5929 2.17525 10.5929 3.625V7.125C10.5929 7.19797 10.5899 7.27024 10.5841 7.3417ZM5.34287 6.08562V7.125C5.34287 8.57475 6.51812 9.75 7.96787 9.75C8.27882 9.75 8.57714 9.69593 8.85394 9.59669L9.68282 10.4256C9.16968 10.6927 8.58641 10.8438 7.96787 10.8438C5.91406 10.8438 4.24912 9.17881 4.24912 7.125C4.24912 6.76256 3.95531 6.46875 3.59287 6.46875C3.23043 6.46875 2.93662 6.76256 2.93662 7.125C2.93662 9.60672 4.73343 11.6688 7.0971 12.0812C7.09429 12.1058 7.09285 12.1309 7.09285 12.1563V14.3438C7.09285 14.7062 7.38666 15 7.7491 15C8.11154 15 8.40535 14.7062 8.40535 14.3438V12.1563L8.40508 12.1375C9.22288 12.0671 9.98476 11.8011 10.6437 11.3865L11.9056 12.6484C12.2181 12.9608 12.7246 12.9608 13.037 12.6484C13.3494 12.336 13.3494 11.8294 13.037 11.517L3.53756 2.01757C3.22514 1.70515 2.71861 1.70515 2.40619 2.01757C2.09377 2.32999 2.09377 2.83652 2.40619 3.14894L5.34287 6.08562ZM11.5083 8.26596L12.5177 9.27538C12.8264 8.62334 12.9991 7.89434 12.9991 7.125C12.9991 6.76256 12.7053 6.46875 12.3429 6.46875C11.9804 6.46875 11.6866 6.76256 11.6866 7.125C11.6866 7.52302 11.6241 7.90644 11.5083 8.26596Z",
    fill: "white",
    fillOpacity: 0.56
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMicOffNoShadow16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-mic-off-no-shadow-16.2d0241320796685a1a391e3ead0af447.svg";